const monsterClasses = [
    "beepy-xko20",
    "mustache-wizard",
    "flying-octopus",
    "walking-root",
    "nautical-crab",
    "metal-hamster"
];

const monsterNames = [
    "Beepy XKO20",
    "Mustache Wizard",
    "Flying Octopus",
    "Walking Root",
    "Nautical Crab",
    "Metal Hamster"
];

export { monsterClasses };
export function monsterClassFromId(monsterId) {
    if (monsterId < 0 || monsterId >= monsterClasses.length) {
        return "unknown-monster";
    }

    return monsterClasses[monsterId];
}

export function monsterNameFromId(monsterId) {
    if (monsterId < 0 || monsterId >= monsterClasses.length) {
        return "???????";
    }

    return monsterNames[monsterId];
}
